import './styles/Experiences.css';
import JobItem from './components/JobItem';
import ScrollReveal from './components/ScrollReveal';
import { useEffect } from 'react';

import { experiencestMeta } from './jobMeta';

function Main() {
    useEffect(() => {
        document.title = 'Work Experience';
    }, []);
    return (
        <>
            <ScrollReveal>
                <div>
                    <div className='jobIntroCenter'>
                        <h1>My work experiences</h1>
                    </div>
                    {experiencestMeta.map((x, i) => {
                        const [name, date, desc, points] = x;

                        return (
                            <div key={i} className={`jobCenter ${i % 2 === 1 ? 'segOne' : 'segTwo'}`}>
                                <JobItem
                                    name={name}
                                    date={date}
                                    desc={desc}
                                    points={points}
                                    reveal={true}
                                    className="experienceBox"
                                />
                            </div>
                        );
                    })}
                </div>
            </ScrollReveal>
        </>
    );
}

export default Main;
